/* @jsxImportSource vue */
<script setup lang="ts">
import { TanstackQueryDevtoolsPanel } from '@tanstack/query-devtools';
import { onlineManager, QueryClient, useQueryClient } from '@tanstack/vue-query';
import { onMounted, onScopeDispose, ref } from 'vue';

const props = defineProps<{client: QueryClient}>()
const client = props.client || useQueryClient()
const panel = ref<null| HTMLElement>()
const queryDevtoolsPanel = new TanstackQueryDevtoolsPanel({
    client,
    queryFlavor: 'Vue Query',
    version: '5',
    onlineManager,
    onClose() {
        queryDevtoolsPanel.unmount()
    },
});

onMounted(() => {
    if (panel.value) {
        queryDevtoolsPanel.mount(panel.value)
    }
})

onScopeDispose(() => {
  queryDevtoolsPanel.unmount()
})

</script>
<template>
    <div ref="panel"/>
</template>